<script lang="ts">
	import Posts from '$lib/components/posts.svelte';
	import { onMount } from 'svelte';
	import type { PageData } from './$types';
	import { browser } from '$app/environment';
	import type { SvelteComponent } from 'svelte';

	export let data: PageData;
	export const { page, posts } = data as PageData & { page: typeof SvelteComponent };

	onMount(() => {
		if (browser) {
			const sharethis = (globalThis as { __sharethis__?: { initialize(): void } }).__sharethis__;
			sharethis?.initialize();
		}
	});
</script>

<svelte:component this={page} />

<section class="mt-12 pt-8 border-t border-border">
	<h3 class="mb-3">Share with your friends</h3>
	<div class="sharethis-inline-share-buttons mb-6"></div>

	<h3 class="mb-3">Related posts</h3>
	<Posts {posts} />
</section>
